const HAS_SCHEME_OR_ANCHOR = /^([a-z][a-z0-9+.-]*:|\/|#)/i;

const ensureAbsoluteUrl = (href: string): string => {
  if (HAS_SCHEME_OR_ANCHOR.test(href)) {
    return href;
  }
  return `https://${href}`;
};

export const getLogoHref = (
  isDefaultLogo: boolean,
  isPaidPlan?: boolean,
  logoHref?: string,
): string | undefined => {
  if (isDefaultLogo && !isPaidPlan && !logoHref) {
    return "https://smartsuite.com";
  }

  if (logoHref) {
    return ensureAbsoluteUrl(logoHref);
  }

  return undefined;
};

export const shouldHideFormLogo = (): boolean => {
  const urlParams = new URLSearchParams(globalThis.location.search);
  return urlParams.get("header") === "false";
};

export const isPopupMode = (): boolean => {
  const urlParams = new URLSearchParams(globalThis.location.search);
  return urlParams.get("display") === "popup";
};

/**
 * Returns true when the form is rendered inside a constrained host surface
 * (modal / slider / external embed) where layout and background styling must
 * be suppressed. Covers:
 * - popup / slider action buttons (?display=popup)
 * - external shared-form embeds (?embed=true — generated by the Embed Code page)
 *
 * Bare `/internal/` renders are intentionally NOT treated as embedded: the
 * in-app Form View, the fullscreen action button, and "open in new tab" all
 * show the form in full, so the configured layout/background applies there.
 */
export const isEmbeddedMode = (): boolean => {
  if (isPopupMode()) return true;
  const urlParams = new URLSearchParams(globalThis.location.search);
  return urlParams.get("embed") === "true";
};
